import Vue from 'vue'

export default {
  state: {
    products: null
  },
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    productsReset(state) {
      state.products = null;
    },
    productDelete(state, id) {
      if (state.products) {
        const index = state.products.findIndex(product => product.id === id);
        if (index !== -1)
          state.products.splice(index, 1);
      }
    },
    productAdd(state, product) {
      if (state.products) {
        const name = product.name.toLowerCase();
        const index = state.products.findIndex(product => name < product.name.toLowerCase());
        if (index !== -1)
          state.products.splice(index, 0, product);
        else
          state.products.push(product);
      }
    },
    productUpdate(state, product) {
      if (state.products) {
        const index = state.products.findIndex(c => c.id === product.id);
        if (index !== -1)
          state.products.splice(index, 1, product);
      }
    }
  },
  actions: {
    async products({state, commit}) {
      if (!state.products) {
        const products = [];
        await Vue.prototype.$lazyListLoad(products, 'products2', 'id,sku,name,category{id},active,upc,scc,mixedPack,containerType', 100, []);
        commit('setProducts', products);
      }

      return state.products;
    },
    /*
    async productCreate({commit}, input) {
      const results = await Vue.prototype.$apiCall(`mutation StoreProduct($input: ProductInput!) {
                                                      productCreate(input:$input) {id,name,active,type,currency,salesRep{id}}
                                                    }`,
                                                    {input});
      if (!results.error)
        commit(input.id ? 'productUpdate' : 'productAdd', results.data.productCreate);
      return results;
    }
    */
  }
}